// Angular Imports
import { Component, EventEmitter, Output, Input, signal, ChangeDetectionStrategy } from '@angular/core'
// Shared Imports
import { MaterialModule } from '@shared/modules'
import { EIcons } from '@shared/models'
import { IconButtonComponent, IconComponent } from '@shared/components'

@Component({
	selector: 'app-pagination',
	standalone: true,
	imports: [MaterialModule, IconComponent, IconButtonComponent],
	templateUrl: './pagination.component.html',
	styleUrls: ['./pagination.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginationComponent {
	@Output() currentPage = new EventEmitter<number>()
	@Output() changeToNext = new EventEmitter<number | null>()
	@Output() changeToPrevious = new EventEmitter<number | null>()
	@Input({ required: true }) itemsPerPage = 10
	@Input({ required: true }) maxItems = 0
	@Input({ required: true }) set pageInitial(pageInitial: number) {
		this.page.set(pageInitial)
	}
	page = signal<number>(1)

	readonly EIcons = EIcons

	get maxPages(): number {
		return Math.ceil(this.maxItems / this.itemsPerPage)
	}

	// get items(): number {
	// 	if (this.itemsPerPage * this.page() > this.maxItems) {
	// 		return this.maxItems
	// 	} else {
	// 		return this.itemsPerPage * this.page()
	// 	}
	// }

	nextPage(): void {
		if (this.maxItems !== 0) {
			if (this.page() !== Math.ceil(this.maxItems / this.itemsPerPage)) {
				this.page.update((previousPage) => previousPage + 1)
				this.currentPage.emit(this.page())
				this.changeToNext.emit(this.page())
			} else {
				this.changeToNext.emit(null)
			}
		} else {
			this.changeToNext.emit(null)
		}
	}

	previousPage(): void {
		if (this.page() === 1) {
			this.page.set(1)
			this.changeToPrevious.emit(null)
		} else {
			this.page.update((previousPage) => previousPage - 1)

			this.currentPage.emit(this.page())
			this.changeToPrevious.emit(this.page())
		}
	}
}
